import { Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { FC } from 'react';
import './BackButton.scss';

type BackButtonProps = {
  title: string;
  backNavigate: () => void;
};
const BackButton: FC<BackButtonProps> = ({ title, backNavigate }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      onClick={backNavigate}
      className="navigation"
    >
      <ArrowBackIcon sx={{ height: '20px', mr: 1 }} />
      {title}
    </Stack>
  );
};
export default BackButton;
